// src/components/gavion/meetings/MarkdownBlocks.tsx
// TEXT-ONLY rendering of pasted Granola notes: React text nodes from markdownToBlocks(), never HTML.
import {
  markdownToBlocks,
  type MdInline,
} from "@/components/gavion/domain/granola";

const Inlines = ({ inlines }: { inlines: MdInline[] }) => (
  <>
    {inlines.map((i, k) =>
      i.bold ? (
        <strong key={k}>{i.text}</strong>
      ) : (
        <span key={k}>{i.text}</span>
      ),
    )}
  </>
);
const HEADINGS = ["h4", "h5", "h6"] as const;

export const MarkdownBlocks = ({
  markdown,
  maxBlocks,
}: {
  markdown: string;
  maxBlocks?: number;
}) => {
  const blocks = markdownToBlocks(markdown);
  const shown = maxBlocks ? blocks.slice(0, maxBlocks) : blocks;
  return (
    <div className="flex flex-col gap-1 text-sm">
      {shown.map((b, k) => {
        if (b.kind === "heading") {
          const Tag = HEADINGS[b.level - 1];
          return (
            <Tag key={k} className="mt-2 font-semibold">
              <Inlines inlines={b.inlines} />
            </Tag>
          );
        }
        if (b.kind === "bullet")
          return (
            <div
              key={k}
              className="flex gap-2"
              style={{ paddingLeft: `${b.depth}rem` }}
            >
              <span aria-hidden="true">
                {b.checked === null ? "•" : b.checked ? "☑" : "☐"}
              </span>
              <span>
                <Inlines inlines={b.inlines} />
              </span>
            </div>
          );
        return (
          <p key={k} className="whitespace-pre-line">
            <Inlines inlines={b.inlines} />
          </p>
        );
      })}
    </div>
  );
};
